<script setup lang="ts">
import {useRoute, useRouter} from "vue-router";
import {Dialog, DialogScrollContent, DialogTitle, DialogDescription} from "@/core/components/ui/dialog";
import {ref, watch} from "vue";
import ExtensionStoreDetailsView from "@/extension/views/ExtensionStoreDetailsView.vue";
import {EXTENSION_DETAILS_QUERY_KEY} from "@/extension/extensionRouter";

const route = useRoute();
const router = useRouter();
const open = ref(false);

watch(() => open.value, (newVal) => {
    if (!newVal) {
        const query = {...route.query};
        delete query[EXTENSION_DETAILS_QUERY_KEY];

        router.replace({query});
    }
});

watch(() => route.query[EXTENSION_DETAILS_QUERY_KEY], (newVal) => {
    open.value = !!newVal;
});
</script>

<template>
  <Dialog v-model:open="open">
    <DialogScrollContent class="max-w-xl md:max-w-3xl lg:max-w-4xl xl:max-w-5xl flex flex-col h-[80%] overflow-auto mx-auto px-0">
      <DialogTitle class="sr-only">
        Extension Details
      </DialogTitle>
      <DialogDescription class="sr-only">
        Extension details modal
      </DialogDescription>
      <ExtensionStoreDetailsView
        v-if="route.query.currentExtensionId"
        :key="route.query.currentExtensionId as string"
        :extension-id="route.query.currentExtensionId as string"
      />
    </DialogScrollContent>
  </Dialog>
</template>

<style scoped>

</style>
